export default "__VITE_ASSET__B62E7faQ__"